import { render, staticRenderFns } from "./FuelStorageClassView.vue?vue&type=template&id=01d21338&scoped=true&"
import script from "./FuelStorageClassView.vue?vue&type=script&lang=js&"
export * from "./FuelStorageClassView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d21338",
  null
  
)

export default component.exports